import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { motion } from 'framer-motion';

const ShippingOne = () => {
    const [shippingItems, setShippingItems] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchShippingData = async () => {
            try {
                setLoading(true);
                const response = await axios.get(`${process.env.REACT_APP_API_URL}/shipping/`);
                setShippingItems(response.data);
                setLoading(false);
            } catch (error) {
                console.error('Error fetching shipping data:', error);
                setLoading(false);
            }
        };

        fetchShippingData();
    }, []);

    if (loading) return null;
    if (!shippingItems || shippingItems.length === 0) return null;

    return (
        <section className="shipping-features py-80">
            <div className="container container-lg">
                <motion.div
                    className="row gy-4"
                    initial="hidden"
                    whileInView="show"
                    viewport={{ once: true }}
                    variants={{
                        hidden: { opacity: 0 },
                        show: {
                            opacity: 1,
                            transition: {
                                staggerChildren: 0.15
                            }
                        }
                    }}
                >
                    {shippingItems.map((item, index) => (
                        <div className="col-xxl-3 col-lg-4 col-sm-6" key={item.id}>
                            <motion.div
                                className="shipping-item"
                                variants={{
                                    hidden: { opacity: 0, y: 30 },
                                    show: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } }
                                }}
                            >
                                <div className="shipping-item__icon-wrap">
                                    <i className={item.icon} />
                                </div>
                                <div className="shipping-item__content">
                                    <h6 className="shipping-item__title">{item.title}</h6>
                                    <p className="shipping-item__subtitle">{item.subtitle}</p>
                                </div>
                            </motion.div>
                        </div>
                    ))}
                </motion.div>
            </div>
        </section>
    );
}

export default ShippingOne;
